module.exports = __webpack_public_path__ + "static/media/AV Level 2.262a8c3e.svg";